module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    staticStyle: {
      "width": "70%",
      "height": "100%"
    },
    attrs: {
      "position": _vm.isNavRight ? 'right' : 'left'
    },
    model: {
      value: (_vm.isShowNavRight),
      callback: function($$v) {
        _vm.isShowNavRight = $$v
      },
      expression: "isShowNavRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowNavRight),
      expression: "isShowNavRight"
    }],
    staticClass: "navRightWrap",
    class: _vm.isNavRight ? 'myNavRightWrapR' : 'myNavRightWrapL'
  }, [_c('div', {
    staticClass: "navPeopleTop",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toMine($event)
      }
    }
  }, [_c('div', {
    staticClass: "peopleWrap"
  }, [_c('div', {
    staticClass: "disBew"
  }, [_c('div', {
    staticClass: "imgPeople"
  }, [(_vm.userInfo.userAvatar) ? _c('van-image', {
    staticClass: "imgWrap",
    attrs: {
      "round": "",
      "fit": "cover",
      "src": _vm.imageUrlBase150(_vm.userInfo.userAvatar)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "textPeople"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.userNickname))]), _vm._v(" "), _c('div', {
    staticClass: "job"
  }, [_vm._v("\n                @" + _vm._s(_vm.userInfo.userCode ? _vm.userInfo.userCode : "暂无入圈号") + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "peopleTag"
  }, [_c('div', {
    staticClass: "list",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toFollow(0)
      }
    }
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.userInfo.followCount)))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("关注")])]), _vm._v(" "), _c('div', {
    staticClass: "list",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toFollow(1)
      }
    }
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.userInfo.followbyCount)) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("粉丝")])]), _vm._v(" "), _c('div', {
    staticClass: "list",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toOtherPage('/interactMessage')
      }
    }
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.userInfo.praisedSum)))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("被赞")])])])]), _vm._v(" "), _c('div', {
    staticClass: "navRightDetail"
  }, [_c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toOtherPage('/mySubscribe')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-icon-xiaoxi1"
    }
  }), _vm._v(" "), _c('span', [_vm._v("预定的活动")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toFollowCLub()
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-quanzi2"
    }
  }), _vm._v(" "), _c('span', [_vm._v("圈子和主题")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toOtherPage('/myComment')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-huati "
    }
  }), _vm._v(" "), _c('span', [_vm._v("帖子和评论")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toOtherPage('/myLike')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-dianzanqian "
    }
  }), _vm._v(" "), _c('span', [_vm._v("我点赞过的")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toOtherPage('/myCollect')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-shoucang "
    }
  }), _vm._v(" "), _c('span', [_vm._v("收藏和足迹")])], 1), _vm._v(" "), _c('div', {
    staticClass: "barLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "navList myFLexBetWeen",
    on: {
      "click": _vm.changeBlack
    }
  }, [_c('div', [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-yueliang"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暗黑模式")])], 1), _vm._v(" "), _c('van-switch', {
    staticClass: "mySwitch",
    attrs: {
      "disabled": "",
      "active-color": "#49E6DA"
    },
    model: {
      value: (_vm.isBlackModel),
      callback: function($$v) {
        _vm.isBlackModel = $$v
      },
      expression: "isBlackModel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navList",
    on: {
      "click": function($event) {
        return _vm.toOtherPage('/toolIndex')
      }
    }
  }, [_c('van-icon', {
    attrs: {
      "class-prefix": "iconfont icon-shezhi "
    }
  }), _vm._v(" "), _c('span', [_vm._v("设置和隐私")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navflexWrap"
  }, [_c('div', {
    staticClass: "list noList"
  }, [_c('van-icon', {
    staticClass: "myIcon",
    attrs: {
      "class-prefix": "iconfont icon-sao"
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫")])], 1), _vm._v(" "), _c('div', {
    staticClass: "list noList"
  }, [_c('van-icon', {
    staticClass: "myIcon",
    attrs: {
      "class-prefix": "iconfont icon-qrcode"
    }
  }), _vm._v(" "), _c('span', [_vm._v("二维码")])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e03b7d7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navBar.vue
// module id = 883
// module chunks = 30 51 74 79 80 81 107 111 117 118 124 125 126